export default "__VITE_ASSET__BPgIK8ve__"